import type { RouterConfig } from '@nuxt/schema'

// Nuxt router options
export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    // Restore on browser back/forward
    if (savedPosition) {
      return savedPosition
    }
    // Default: scroll to top on route change
    return { left: 0, top: 0 }
  },
}
